import { render, staticRenderFns } from "./WhyUs.vue?vue&type=template&id=6e1e48cf"
import script from "./WhyUs.vue?vue&type=script&lang=js"
export * from "./WhyUs.vue?vue&type=script&lang=js"
import style0 from "./WhyUs.vue?vue&type=style&index=0&id=6e1e48cf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../repos/mylovelyladyhere.com/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports